import React, {Component} from 'react';
import PropTypes from 'prop-types';
import Wrapper from '../../components/wrapper';
import SubNavigationPc from './pc';
import SubNavigationTb from './tb';
import SubNavigationMb from './mb';
import SubNavigationLower from './lower';
import './styles.css';
import {DOCUMENT, IS_MOBILE, WINDOW} from "../../constants/environment";

/**
 * SubNavigation
 */
class SubNavigation extends Component {
  static propTypes = {
    containerId: PropTypes.string,
    containerClass: PropTypes.string,
    pcTitle: PropTypes.string,
    mbTitle: PropTypes.string,
    carsTitle: PropTypes.bool,
    deleteRootPageLink: PropTypes.bool,
    rootLink: PropTypes.shape({
      pageName: PropTypes.string,
      pcText: PropTypes.string,
      mbText: PropTypes.string,
      href: PropTypes.string,
      external: PropTypes.bool,
    }),
    estimationHistory: PropTypes.arrayOf(PropTypes.node),
    links: PropTypes.arrayOf(PropTypes.shape({
      pageName: PropTypes.string,
      pcText: PropTypes.string,
      mbText: PropTypes.string,
      href: PropTypes.string,
      external: PropTypes.bool,
      nestedNavigation: PropTypes.object,
    })),
    position: PropTypes.bool,
    display: PropTypes.bool,
  };
  static defaultProps = {
    containerId: null,
    containerClass: null,
    pcTitle: null,
    mbTitle: null,
    carsTitle: null,
    deleteRootPageLink: false,
    rootLink: null,
    estimationHistory: null,
    links: null,
    position: null,
    display: null,
  };

  constructor(props) {
    super();
    this.props = props;
    this.state = {
      fixed: false,
      hierarchy: this.getHierarchy(),
      top: 0,
    };
    // PCでの段表示
    this.stepsClass = this.getStepsClass();

    this.isExistHeader = true;
  }

  componentDidMount() {

    if (DOCUMENT.querySelector('.Header')) {
      this.isExistHeader = true;
    } else {
      this.isExistHeader = false;
    }

    window.addEventListener('scroll', this.handleScroll);
    this.handleScroll();
    // 階層
    this.setState({
      hierarchy: this.getHierarchy(location.pathname)
    });

    // EPIServerのプレビュー時のモーダルの位置調整
    // if (WINDOW && WINDOW.epi && WINDOW.parent && !IS_MOBILE) {
    if (WINDOW && WINDOW.epi && WINDOW.parent && window.matchMedia('(min-width:768px)').matches) {
      const wrapperElement = WINDOW.parent.document.querySelector("div[data-dojo-attach-point='previewContainer']");
      if (wrapperElement) {
        setInterval(()=> {
          this.onScrollEpiPreview();
        }, 200)
      }
    }

  }

  componentWillUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  }

  render() {
    if (this.props.display === true) {
      return (
        <Wrapper
          containerId={this.props.containerId}
          containerClass={this.props.containerClass}
        >
          {(() => {
            if (this.props.position === false) {
              return (
                <section className={'SubNavigation' + ((this.state.fixed === true) ? ' fixed': '') + this.stepsClass} ref='self'>
                  <div className="SubNavigation__container" style={(()=> {
                    if (0 < this.state.top) {
                      return {
                        position: 'absolute',
                        top: this.state.top + 'px'
                      }
                    }
                    return null;
                  })()}>
                    <SubNavigationPc
                      pcTitle={this.props.pcTitle}
                      mbTitle={this.props.mbTitle}
                      carsTitle={this.props.carsTitle}
                      rootLink={this.props.rootLink}
                      estimationHistory={this.props.estimationHistory}
                      links={this.props.links}
                      hierarchy={this.state.hierarchy}
                      subNavigation={this.refs.self}
                      deleteRootPageLink={this.props.deleteRootPageLink}
                    />
                    <SubNavigationTb
                      pcTitle={this.props.pcTitle}
                      mbTitle={this.props.mbTitle}
                      carsTitle={this.props.carsTitle}
                      rootLink={this.props.rootLink}
                      estimationHistory={this.props.estimationHistory}
                      links={this.props.links}
                      hierarchy={this.state.hierarchy}
                      deleteRootPageLink={this.props.deleteRootPageLink}
                    />
                    <SubNavigationMb
                      pcTitle={this.props.pcTitle}
                      mbTitle={this.props.mbTitle}
                      carsTitle={this.props.carsTitle}
                      rootLink={this.props.rootLink}
                      estimationHistory={this.props.estimationHistory}
                      links={this.props.links}
                      hierarchy={this.state.hierarchy}
                      deleteRootPageLink={this.props.deleteRootPageLink}
                    />
                  </div>
                </section>
              )
            } else {
              return (
                <section className={'SubNavigation' + ((this.props.position === true) ? ' lower': '')}>
                  <SubNavigationLower
                    pcTitle={this.props.pcTitle}
                    mbTitle={this.props.mbTitle}
                    carsTitle={this.props.carsTitle}
                    rootLink={this.props.rootLink}
                    estimationHistory={this.props.estimationHistory}
                    links={this.props.links}
                    hierarchy={this.state.hierarchy}
                  />
                </section>
              )
            }
          })()}
        </Wrapper>
      )
    } else {
      return null
    }
  }

  //
  handleScroll = () => {
    const top = document.documentElement.scrollTop || document.body.scrollTop;
    const fixed = this.state.fixed;
    let fixedTop = 0;
    if (this.isExistHeader) {
      if (window.matchMedia('(min-width:768px)').matches) {
        fixedTop = 94;
      } else {
        fixedTop = 60;
      }
    }
    if (fixedTop <= top) {
      if (fixed === true) return;
      this.setState({
        fixed: true,
      });
    } else {
      if (fixed === false) return;
      this.setState({
        fixed: false,
      });
    }
  };

  // EPIServerのプレビュー時のモーダルの位置調整
  onScrollEpiPreview = ()=> {
    const wrapperElement = WINDOW.parent.document.querySelector("div[data-dojo-attach-point='previewContainer']");
    if (wrapperElement) {
      const top = wrapperElement.scrollTop;
      const fixed = this.state.fixed;
      let fixedTop = 0;
      if (this.isExistHeader) {
        if (window.matchMedia('(min-width:768px)').matches) {
          fixedTop = 94;
        } else {
          fixedTop = 60;
        }
      }
      if (fixedTop <= top) {
        this.setState({
          fixed: true,
          top: top - fixedTop,
        });
      } else {
        if (fixed === false) return;
        this.setState({
          fixed: false,
          top: 0,
        });
      }
    }
  }

  // PCでの段表示
  getStepsClass = ()=> {
    let stepsClass = ' one-steps';
    if (this.props.links !== null && 1 <= this.props.links.length) {
      this.props.links.map((link, index) => {
        if (link.current === true) {
          if (link.nestedNavigation !== null) {
            if (link.nestedNavigation.links !== null && 1 <= link.nestedNavigation.links.length) {
              stepsClass = ' two-steps';
            }
          }
        }
      });
    }
    return stepsClass;
  };

  // 階層
  getHierarchy = (pathname)=> {
    let hierarchy = 1;
    if (this.props.links !== null && 1 <= this.props.links.length) {
      let i, max;
      for (i = 0, max = this.props.links.length; i < max; i = i + 1) {
        const link = this.props.links[i];
        if (link.current === true) {
          hierarchy = 2;
          if (link.nestedNavigation !== null) {
            if (link.nestedNavigation.links !== null && 1 <= link.nestedNavigation.links.length) {

              // 下階層のTOPリンクのURLと現在のページのURLが一致していた場合に下線を表示しない処理
              if (pathname && link.nestedNavigation.topLink && link.nestedNavigation.topLink.href) {
                if (link.nestedNavigation.topLink.href === pathname) {
                  return 3;
                }
              }

              let j, max2;
              for (j = 0, max2 = link.nestedNavigation.links.length; j < max2; j = j + 1) {
                const link2 = link.nestedNavigation.links[j];
                if (link2.current === true) {
                  hierarchy = 3;
                  if (link2.nestedNavigation !== null) {
                    if (link2.nestedNavigation.links !== null && 1 <= link2.nestedNavigation.links.length) {
                      let k, max3;
                      for (k = 0, max3 = link2.nestedNavigation.links.length; k < max3; k = k + 1) {
                        const link3 = link2.nestedNavigation.links[k];
                        if (link3.current === true) {
                          hierarchy = 4;
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
    return hierarchy;
  }

}

export default SubNavigation;



// WEBPACK FOOTER //
// ./src/containers/sub-navigation/index.jsx